<template>

    <v-dialog v-model="dialogModel" :max-width="1200">
        <toolbar :title="'Permissions (' + items.length + ')'" icon="mdi-shield-account">
            <template slot="buttons">
                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn id="closeButton" @click="closeClicked" v-on="on" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close this dialog</span>
                </v-tooltip>
            </template>
        </toolbar>
        <v-card>
            <v-card-text class="pt-2">
                <v-container class="pa-1">
                    <v-row no-gutters>
                        <v-col cols="4" v-for="permission in permissions"
                               :key="permission.id">
                            <v-list class="pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon color="grey">mdi-check-circle</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <div class="d-flex">
                                            <div class="align-self-center">
                                                {{ ucFirst(permission.name) }}
                                            </div>
                                            <div class="align-self-center">
                                                <v-tooltip color="primary" top max-width="300">
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon
                                                            v-if="permission.dangerous"
                                                            class="ml-2"
                                                            v-on="on"
                                                            color="amber darken-2">
                                                            mdi-alert
                                                        </v-icon>
                                                    </template>
                                                    <span>
                                                        Potential dangerous permission! Make sure only appropriate people are given this role.
                                                    </span>
                                                </v-tooltip>
                                            </div>
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

    </v-dialog>

</template>

<script>

import ToolbarPage from '../../../components/UI/ToolbarPage';
import {dangerousPermissionsMixin} from "../../../components/mixins/dangerousPermissionsMixin";

export default {

    mixins: [dangerousPermissionsMixin],

    components: {
        'toolbar': ToolbarPage
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        },
        items: {
            type: Array,
            required: false,
        },
    },

    computed: {
        dialogModel: {
            get() {
                return this.value;
            },
            set() {
                this.closeClicked();
            }
        },

        permissions() {
            if (this.items) {
                return this.items.map(permission => {
                    if (this.dangerousPermissions.includes(permission.name)) {
                        permission.dangerous = true;
                    }
                    return permission;
                });
            }
            return [];
        }
    },

    methods: {

        closeClicked() {
            this.$emit('input', false);
        },

        isDangerousPermission(permissionName) {
            return ['export panelists', 'view pi'].includes(permissionName);
        }
    },

    watch: {
        items(newValue) {
            this.model = newValue;
        }
    }
}
</script>
